import StyleCategoriesContainer from "./StyleCategoriesContainer";
import UpdateStyleCategoryContainer from "./UpdateStyleCategoryContainer";

export { StyleCategoriesContainer, UpdateStyleCategoryContainer };
